import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';

import { ModuloAdmin, ModuloUfItem } from './modulo-admin.model';

/** Admin (CFM) de módulos por UF — Configurações → Gerais → Módulos. Ver `PortalModuloService` para o dashboard (read-only). */
@Injectable({ providedIn: 'root' })
export class ModuloAdminService extends BaseService {
    readonly PATH = environment.basePath + '/portal/modulo';

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /** Lista os módulos com o estado (global e da UF) para a tela admin — `GET /portal/modulo/admin?uf={UF}`. */
    listarPorUf(uf: string): Observable<ModuloAdmin[]> {
        const params = new HttpParams().set('uf', uf);
        return this.http.get<ModuloAdmin[]>(`${this.PATH}/admin`, { params });
    }

    /** Atualiza nome/descrição de um módulo — `PUT /portal/modulo/admin/{id}`. */
    editar(id: number, body: { nmModulo: string; dsModulo: string }): Observable<void> {
        return this.http.put<void>(`${this.PATH}/admin/${id}`, body);
    }

    /** Habilita/desabilita em lote os módulos de uma UF — `PUT /portal/modulo/admin/uf/{UF}`. */
    salvarLoteUf(uf: string, itens: ModuloUfItem[]): Observable<void> {
        return this.http.put<void>(`${this.PATH}/admin/uf/${encodeURIComponent(uf)}`, { itens });
    }
}
